import Vue from 'vue'
import { createHash } from 'crypto'

Vue.prototype.$sha256 = password => createHash('sha256').update(password, 'utf8').digest('hex')
